<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1_100)">
<circle cx="12" cy="12" r="12" fill="currentColor"/>
<path d="M9.75 8C9.75 7.58579 9.41421 7.25 9 7.25C8.58579 7.25 8.25 7.58579 8.25 8V16C8.25 16.4142 8.58579 16.75 9 16.75C9.41421 16.75 9.75 16.4142 9.75 16V8Z" fill="white"/>
<path d="M15.75 8C15.75 7.58579 15.4142 7.25 15 7.25C14.5858 7.25 14.25 7.58579 14.25 8V16C14.25 16.4142 14.5858 16.75 15 16.75C15.4142 16.75 15.75 16.4142 15.75 16V8Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_1_100">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
